import {
    listBlocks as repoListBlocks,
    createBlock as repoCreateBlock,
    deleteBlock as repoDeleteBlock,
} from '../infrastructure/blocks.repository.js';

/**
 * Servicio de bloqueos de disponibilidad para el panel de staff (Fase 1).
 * Orquesta el repositorio (I/O); no contiene lógica de Supabase.
 */

/**
 * Fecha local de hoy en formato ISO `YYYY-MM-DD`. Mismo enfoque que
 * `todayLocalISO` en admin-reservations.service.js: hora local, no UTC,
 * para evitar desplazamientos de día por zona horaria.
 * @param {Date} [now] — injectable para tests (default `new Date()`)
 * @returns {string}
 */
function todayLocalISO(now = new Date()) {
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * Trae los bloqueos desde `from` (inclusive). Si no se especifica `from`, usa
 * la fecha local de hoy.
 * @param {{ from?: string }} [params] fecha ISO (YYYY-MM-DD), límite inferior inclusive
 * @returns {Promise<Array<object>>}
 * @throws {Error} si el repositorio falla
 */
export async function loadBlocks({ from } = {}) {
    const effectiveFrom = from ?? todayLocalISO();
    return repoListBlocks({ from: effectiveFrom });
}

/**
 * @typedef {{ ok: boolean, error?: string, block?: object }} CreateBlockResult
 */

/**
 * Crea un bloqueo nuevo validando que `fecha` y `reason` sean provistos.
 * @param {{ fecha?: string, momento?: string|null, area?: string|null, reason?: string }} input
 * @returns {Promise<CreateBlockResult>}
 */
export async function createBlock(input) {
    if (!input.fecha) {
        return { ok: false, error: 'La fecha es obligatoria' };
    }
    if (!input.reason?.trim()) {
        return { ok: false, error: 'El motivo es obligatorio' };
    }

    const block = await repoCreateBlock({
        fecha: input.fecha,
        momento: input.momento ?? null,
        area: input.area ?? null,
        reason: input.reason.trim(),
    });

    return { ok: true, block };
}

/**
 * Elimina un bloqueo por id.
 * @param {string} id
 * @returns {Promise<void>}
 * @throws {Error} si el repositorio falla
 */
export async function deleteBlock(id) {
    return repoDeleteBlock(id);
}
